import { Component ,ElementRef,OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportService } from 'src/app/services/report.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx'; 
import Swal from 'sweetalert2'

// CommonJS

@Component({
  selector: 'smart-report-overview',
  templateUrl: './report-overview.component.html',
  styleUrls: ['./report-overview.component.scss','../report.component.scss'],
})
export class ReportOverviewComponent implements OnInit {
  dashboardName:string=''
  role:string=''
  farmId:any
  zoneId:any
  plotId:any
  poleId:any
  poleName:any
  child_org:string=''
  filter_date:any=[]
  today:any=''
  filter_monthyear_start:any=''
  filter_monthyear_end:any=''
  filter_monthyear_start_show:any=''
  filter_monthyear_end_show:any=''
  permission_filter_zone :boolean=false
  permission_filter_plot:boolean=false
  permission_filter_pole:boolean=false
  farm_list:any=[]
  farm_list_filter:any=[]
  zone_list:any =[]
  zone_list_filter:any=[]
  plot_list:any=[]
  plot_list_filter:any=[]
  pole_list:any=[]
  pole_list_filter:any=[]
  data_table:any=[]

  multi_data_farmlist:any=[]
  multi_data_zonelist:any=[]
  multi_data_plotlist:any=[]
  multi_data_polelist:any=[]
  filterdropdown_farm:any=''
  filterdropdown_zone:any=''
  filterdropdown_plot:any=''
  filterdropdown_pole:any=''
  format_month_year=[]
  month_list_start=[]
  month_list_end=[]
  yearselect_start=''
  yearselect_end=''
  before_data_year_start:any
  before_data_year_end:any
  before_data_month_start:any
  before_data_month_end:any
  now_select_year:any
  last_select_month:any=''
  rollback_css= 'col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center'
  active_css = 'col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center activeselect'
  @ViewChild('myDivstart') myDivstart: ElementRef;
  @ViewChild('myDivend') myDivend: ElementRef;
  
  constructor(
     private route: ActivatedRoute,
     private reportservice:ReportService,
     private spinner: NgxSpinnerService,
  ) { 
   
    this.role = sessionStorage.getItem("role")
    this.child_org=sessionStorage.getItem("ChildOrg")
    this.today =new Date()
    this.dashboardName = this.route.snapshot.queryParams["dashboardName"];
    this.checkpermission_filter()



  }
  

  ngOnInit(): void {}
  checkpermission_filter(){
    if(this.dashboardName =='ภาพรวมดอกรายปีการปลูกวนิลา' || this.dashboardName =='ภาพรวมฝักรายปีการปลูกวนิลา'){
      this.farmId=sessionStorage.getItem("farmId")
    }
    else if(this.dashboardName =='ภาพรวมดอกรายเสาปลูกวนิลา' || this.dashboardName =='ภาพรวมฝักรายเสาปลูกวนิลา'){
      this.farmId=[]
      this.zoneId=[]
      this.poleId=[]
      this.plotId=[]
      this.poleName=[]
      this.permission_filter_plot = true
      this.permission_filter_pole = true
    }else if(this.dashboardName =='ภาพรวมดอกแต่ละแปลงการปลูกวนิลา'||this.dashboardName=="ภาพรวมฝักแต่ละแปลงการปลูกวนิลา"){
      this.farmId=[]
      this.zoneId=[]
      this.poleId=[]
      this.plotId=[]
      this.poleName=[]
      this.permission_filter_plot = true
    }
    this.GetFarmList()
  }


 

  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };     
    container.setViewMode('month');
   }

  callback(eventData:any) {
    this.data_table=eventData
    if(this.data_table.length == 0){
      Swal.fire({
        icon: 'warning',
        title: 'ไม่พบข้อมูล',
        showConfirmButton: false,
        timer: 3000
      })
    }

  }


  Selectmonth(year,number,month,disable,type,select_month:HTMLElement){
    this.last_select_month=select_month
    if(disable == false && type =='start'){
      this.filter_monthyear_start_show = month+'-'+year
      this.filter_monthyear_start = number+'/1/'+year
      this.myDivstart.nativeElement.className = 'dropdown-menu'
      this.yearselect_start = year
      this.format_filterdate()
      if(this.before_data_month_start){
        if(this.before_data_month_start.textContent != month){
          this.before_data_month_start.className = this.rollback_css
          select_month.className = this.active_css
          this.before_data_month_start = select_month
        }
      }else{
        this.before_data_month_start = select_month
        select_month.className = this.active_css
      }
    }else if(disable == false && type =='end'){
      this.filter_monthyear_end_show = month+'-'+year
      this.filter_monthyear_end = number+'/1/'+year
      this.myDivend.nativeElement.className = 'dropdown-menu'
      this.format_filterdate()
      if(this.before_data_month_end){
        if(this.before_data_month_end.textContent != month){
          this.before_data_month_end.className = this.rollback_css
          select_month.className = this.active_css
          this.before_data_month_end = select_month
        }
      }else{
        this.before_data_month_end = select_month
        select_month.className = this.active_css
      }
    }

  }




  GetFarmList(){
    this.farm_list =[]
    this.zone_list =[]
    this.plot_list =[]
    this.pole_list =[]
    this.spinner.show()
    this.reportservice.getFarmList().subscribe(
      async result => {
        if (result.code == 200) {
          this.farm_list = result.data.FarmList
          this.farm_list_filter = result.data.FarmList
          this.spinner.hide()
          if(!this.permission_filter_zone && !this.permission_filter_plot && !this.permission_filter_pole){
            this.farmId = this.farm_list[0]._id
            this.createFilter()
          }else{
            // this.GetPlotList()
            this.Set_multidata('farmlist',0,this.farm_list[0].name,this.farm_list[0]._id,true)
          }
          // this.GetZoneList()
        }else{
          this.spinner.hide()
          this.farm_list =[]
          this.zone_list =[]
          this.plot_list =[]
          this.pole_list =[]
        }
      }
    )
  }

  GetPlotList(){
    this.plot_list =[]
    this.pole_list =[]
    this.spinner.show()
    let body ={
      farm_ids: this.farmId,
      child_org_id: this.child_org,
      zone_ids:this.zoneId
    }
    // if(this.permission_filter_plot){
      this.reportservice.getPlotList(body).subscribe(
        async result => {
          if (result.code == 200) {
            this.spinner.hide()
            this.plot_list = result.data
            this.plot_list_filter = result.data

            // this.plotId = this.plot_list[0]._id
            if(this.dashboardName =='ภาพรวมดอกรายเสาปลูกวนิลา' || this.dashboardName =='ภาพรวมฝักรายเสาปลูกวนิลา'){
              this.GetPoleList()
            }
          }else{
            this.spinner.hide()
            this.plot_list =[]
            this.pole_list =[]
          }
        }
      )
    // }
  }
  GetPoleList(){
    this.pole_list =[]
    this.spinner.show()
    let body ={
      farm_ids: this.farmId,
      child_org_id: this.child_org,
      zone_ids:this.zoneId,
      plot_ids: this.plotId
    }
    // if(this.permission_filter_pole){
      this.reportservice.getPoleList(body).subscribe(
        async result => {
          if (result.code == 200) {
            this.spinner.hide()
            this.pole_list = result.data
            this.pole_list_filter = result.data

            // this.poleId = this.pole_list[0]._id
            // this.poleName= this.pole_list[0].name
          }else{
            this.spinner.hide()
            this.pole_list =[]
          }
        }
      )
    // }

  }
  Set_multidata(type,index,name,id,first_time:any=false){
    if(type == 'farmlist'){
      this.multi_data_farmlist.push({name:name,_id:id,old_index:index})
      this.farm_list.splice(index,1)
      this.farmId.push(id)
      this.farmId = this.farmId.slice();
      this.multi_data_zonelist=[]
      this.multi_data_plotlist=[]
      this.multi_data_polelist=[]
      this.zoneId=[]
      this.plotId=[]
      this.poleName=[]
      this.GetPlotList()
    }

    else if(type == 'plotlist'){
      this.multi_data_plotlist.push({name:name,_id:id,old_index:index})
      this.plot_list.splice(index,1)
      this.plotId.push(id)
      this.plotId = this.plotId.slice();
      this.multi_data_polelist=[]
      this.poleName=[]
      this.GetPoleList()
    }else if(type == 'polelist'){
      this.multi_data_polelist.push({name:name,_id:id,old_index:index})
      this.pole_list.splice(index,1)
      this.poleName.push(name)
      this.poleName = this.poleName.slice();
    }
    if(first_time){
      this.createFilter()
    }
  }
  Remove_multidata(type,index){
    if(type == 'farmlist'){
      this.farm_list.splice(this.multi_data_farmlist[index].old_index, 0, {name:this.multi_data_farmlist[index].name,_id:this.multi_data_farmlist[index]._id});
      this.farmId.filter(item=>{
        if(item == this.multi_data_farmlist[index]._id){
          let _index = this.farmId.indexOf(this.multi_data_farmlist[index]._id)
          this.farmId.splice(_index,1)
          this.farmId = this.farmId.slice();
        }
      })
      this.multi_data_farmlist.splice(index,1)
      this.multi_data_zonelist=[]
      this.multi_data_plotlist=[]
      this.multi_data_polelist=[]
      this.zoneId=[]
      this.plotId=[]
      this.poleName=[]
      this.GetPlotList
    }
    else if(type == 'plotlist'){
      this.plot_list.splice(this.multi_data_plotlist[index].old_index, 0, {name:this.multi_data_plotlist[index].name,_id:this.multi_data_plotlist[index]._id});
      this.plotId.filter(item=>{
        if(item == this.multi_data_plotlist[index]._id){
          let _index = this.plotId.indexOf(this.multi_data_plotlist[index]._id)
          this.plotId.splice(_index,1)
          this.plotId = this.plotId.slice();

        }
      })
      this.multi_data_plotlist.splice(index,1)
      this.multi_data_polelist=[]
      this.poleName=[]
      this.GetPoleList()
    }else if(type == 'polelist'){
      this.pole_list.splice(this.multi_data_polelist[index].old_index, 0, {name:this.multi_data_polelist[index].name,_id:this.multi_data_polelist[index]._id});
      this.poleName.filter(item=>{
        if(item == this.multi_data_polelist[index].name){
          let _index = this.poleName.indexOf(this.multi_data_polelist[index].name)
          this.poleName.splice(_index,1)
          this.poleName = this.poleName.slice();

        }
      })
      this.multi_data_polelist.splice(index,1)
    }

  }
  async createFilter(){
    let today =  new Date();
    let format_array=[]
    let year_array =[]
    let month_array =[]
    let year_now = today.getFullYear()
    let month_now = today.getMonth()+1
    let limit_year = 2
    let limit_month = limit_year * 12
    let chek_month_limit = false
    format_array.push(month_now)
    for(let i = 1;i <= limit_month ;i++ ){
      let num = Math.abs(month_now-i)
      if(num == 13){
        chek_month_limit= true
      }
      if(num != 0 ){
        format_array.push(num)
      }
    }
    var p1 = format_array.slice(0,month_now);
    p1 = p1.reverse();
    var p2 = format_array.slice(month_now,(12+month_now));
    var p3:any

    for(let i = 0 ;i < 12 ;i++){
      if(p1[i]!=undefined && p1[i]!='' && p1[i]!=null){
        p1[i]={
          number:p1[i],
          month:this.format_month_eng(p1[i]),
          disable:false
        }
      }else{
        p1[i]={
          number:i+1,
          month:this.format_month_eng(i+1),
          disable:true
        }
      }
      if(p2[i]!=undefined && p2[i]!='' && p2[i]!=null){
        p2[i]={
          number:p2[i],
          month:this.format_month_eng(p2[i]),
          disable:false
        }
      }else{
        p2[i]={
          number:i+1,
          month:this.format_month_eng(i+1),
          disable:true
        }
      } 
    }
    month_array.push(p1,p2)
    if(chek_month_limit){
        p3 = format_array.slice((12+month_now),limit_month);
        for(let i = 0;i < p3.length ;i++ ){
          p3[i] = parseInt(p3[i])-p3.length
        }
        let minus=(p3.length-1)
        for(let i = 0 ;i < 12 ;i++){
          if(p3[i]==undefined || p3[i]=='' || p3[i]==null){
            p3[i]={
              number:i-minus,
              month:this.format_month_eng(i-minus),
              disable:true
            }
          }else{
            p3[i]={
              number:p3[i],
              month:this.format_month_eng(p3[i]),
              disable:false
            }
          }
        }
      p3.sort(function (a, b) {
        return a.number - b.number;
      });
      month_array.push(p3)
    }
 
    month_array.reverse()
    for(let i = month_array.length ;i >= 1 ;i-- ){
      year_array.push((year_now+1)-i)
    }
    await Promise.all( year_array.map((item,index)=>{
      year_array[index]={
       year:item,
       month:month_array[index]
      }
    }))
    this.format_month_year = year_array  
    let start_month_number = ''
    let start_month = ''
    let end_month_number = ''
    let end_month = ''
    let last_index = this.format_month_year.length-1
    for(let i = 0; i < this.format_month_year[0].month.length ;i++){
      if(this.format_month_year[0].month[i].disable == false){
        start_month_number=this.format_month_year[0].month[i].number
        start_month =this.format_month_year[0].month[i].month
        break;
      }
    } 
    for(let i = this.format_month_year[last_index].month.length -1; i >= 0 ;i--){
      if(this.format_month_year[last_index].month[i].disable == false){
        end_month_number=this.format_month_year[last_index].month[i].number
        end_month =this.format_month_year[last_index].month[i].month
        break;
      }
    }
    this.filter_monthyear_start_show = start_month+'-'+this.format_month_year[0].year
    this.filter_monthyear_start = start_month_number+'/1/'+this.format_month_year[0].year
    this.filter_monthyear_end_show = end_month+'-'+this.format_month_year[last_index].year
    this.filter_monthyear_end = end_month_number+'/1/'+this.format_month_year[last_index].year

    this.format_filterdate()

  }
  Filterdropdown(type:any){
    if(type =='farmlist'){
      let list_true:any=[]
      let list_false:any=[]
      this.farm_list_filter.map(item=>{
        if(item.name.indexOf(this.filterdropdown_farm) != -1){
            list_true.push(item)
        }else{
            list_false.push(item)
        }
      })
      if((this.filterdropdown_farm != null && this.filterdropdown_farm != undefined && this.filterdropdown_farm !='') && list_true.length !=0){
        this.farm_list = list_true
      }else if((this.filterdropdown_farm == null || this.filterdropdown_farm == undefined || this.filterdropdown_farm =='') && list_true.length != 0){
        this.farm_list = this.farm_list_filter
      }else if(this.filterdropdown_farm != null && this.filterdropdown_farm !=undefined && this.filterdropdown_farm !='' && list_true.length == 0){        
        this.farm_list = []
      }else{
        this.farm_list = this.farm_list_filter
      }
    }
    else if(type =='plotlist'){
      let list_true:any=[]
      let list_false:any=[]
      this.plot_list_filter.map(item=>{
        if(item.name.indexOf(this.filterdropdown_plot) != -1){
            list_true.push(item)
        }else{
            list_false.push(item)
        }
      })
      if((this.filterdropdown_plot != null && this.filterdropdown_plot != undefined && this.filterdropdown_plot !='') && list_true.length !=0){
        console.log(list_true)
        this.plot_list = list_true
      }else if((this.filterdropdown_plot == null || this.filterdropdown_plot == undefined || this.filterdropdown_plot =='') && list_true.length != 0){
        this.plot_list = this.plot_list_filter
      }else if(this.filterdropdown_plot != null && this.filterdropdown_plot !=undefined && this.filterdropdown_plot !='' && list_true.length == 0){        
        this.plot_list = []
      }else{
        this.plot_list = this.plot_list_filter
      }
    }else if(type =='polelist'){
      let list_true:any=[]
      let list_false:any=[]
      this.pole_list_filter.map(item=>{
        if(item.name.indexOf(this.filterdropdown_pole) != -1){
            list_true.push(item)
        }else{
            list_false.push(item)
        }
      })
      if((this.filterdropdown_pole != null && this.filterdropdown_pole != undefined && this.filterdropdown_pole !='') && list_true.length !=0){
        this.pole_list = list_true
      }else if((this.filterdropdown_pole == null || this.filterdropdown_pole == undefined || this.filterdropdown_pole =='') && list_true.length != 0){
        this.pole_list = this.pole_list_filter
      }else if(this.filterdropdown_pole != null && this.filterdropdown_pole !=undefined && this.filterdropdown_pole !='' && list_true.length == 0){        
        this.pole_list = []
      }else{
        this.pole_list = this.pole_list_filter
      }
    }

  }



  canDownload(role){
    if( role == 'admin' || role == 'farm_manager'){
      return true
    }else{
      return false
    }
  }
  clear_filetr_date(){
    this.filter_monthyear_start = ''
    this.filter_monthyear_end = ''
    this.filter_monthyear_start_show = ''
    this.filter_monthyear_end_show = ''
    this.createFilter()

  }
  format_filterdate(){ 
    if(
    (this.filter_monthyear_start !=null  && this.filter_monthyear_start != '' && this.filter_monthyear_start != undefined)&& 
    (this.filter_monthyear_end !=null  && this.filter_monthyear_end != '' && this.filter_monthyear_end != undefined)&&
    (new Date(this.filter_monthyear_start) > new Date(this.filter_monthyear_end))){
      Swal.fire({
        icon: 'warning',
        title: 'วันที่ไม่ถูกต้อง',
        showConfirmButton: false,
        timer: 3000
      })
      this.clear_filetr_date()

    }else if((this.filter_monthyear_start !=null  && this.filter_monthyear_start != '' && this.filter_monthyear_start != undefined)&& 
    (this.filter_monthyear_end !=null  && this.filter_monthyear_end != '' && this.filter_monthyear_end != undefined)){
        this.filter_date=[]
        let d1 = new Date(this.filter_monthyear_start) 
        let d2 = new Date(this.filter_monthyear_end)  
        var months;
        let cap = 0
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        
        cap = months <= 0 ? 0 : months
        var month:any =0
        var limit_month = 12
        var year = d1.getFullYear()
          for(let i=0 ;i <= cap;i++){
             month = d1.getMonth()+1+i <= 9 ? '0'+(d1.getMonth()+1+i):(d1.getMonth()+1+i)
           
             if(month > limit_month){
              month = month-limit_month <= 9 ? '0'+(month-limit_month):month-limit_month
             }
             if(month > 12 ){
              month = month-12 <= 9 ? '0'+(month-12):month-12
              limit_month +=12
             }
            if(parseInt(month) == 1 ){
                year +=1
            }
            this.filter_date.push(year+'-'+month)
          }
          let check_first =this.filter_date[0].split('-')
          if(this.filter_date.length <=12){
            if(parseInt(check_first[1])==1){ 
              this.filter_date.map((item,index)=>{
              let split = item.split('-')
              this.filter_date[index]=this.yearselect_start+'-'+split[1]
              })
            }
          }else{
            if(parseInt(check_first[1])==1 && this.filter_date.length >12){
              this.filter_date.map((item,index)=>{
                let split = item.split('-')
                this.filter_date[index]=(parseInt(split[0])-1)+'-'+split[1]
                })
            }
          }
          




    }

  }
  async format_export(type:string){
    if(this.data_table.length!=0){
      if(this.dashboardName =='ภาพรวมดอกรายปีการปลูกวนิลา'){
        if(type =='csv'){
          let format_list=[]
          const header = ['ฟาร์ม','เดือน','ปี','จำนวนดอกดี','จำนวนดอกเสีย','จำนวนดอกทั้งหมด','ประเภท']
          await this.data_table.map(data=>{
            format_list.push({'farm_name':data.farm_name,'month':data.month,'year':data.year,'sum_good_data':data.sum_good_data,'sum_fail_data':data.sum_fail_data,'sum_all_data':data.sum_all_data,'group_type':data.group_type})
          })
          this.exportCSV(header,format_list)
        }else if (type =='xlsx'){
          var td=''
          this.data_table.map(data=>{
            td += 
            '<tr>'
            +'<td>'+data.farm_name+'</td>'
            +'<td>'+data.month+'</td>'
            +'<td>'+data.year+'</td>'
            +'<td>'+data.sum_good_data+'</td>'
            +'<td>'+data.sum_fail_data+'</td>'
            +'<td>'+data.sum_all_data+'</td>'
            +'<td>'+data.group_type+'</td>'
            +'</tr>'
          })
      
           var element2 = `<table > 
           <tr >       
              <th >ฟาร์ม</th> 
              <th >เดือน</th>  
              <th >ปี</th> 
              <th >จำนวนดอกดี</th> 
              <th >จำนวนดอกเสีย</th> 
              <th >จำนวนดอกทั้งหมด</th> 
              <th >ประเภท</th> 
           </tr>`+td+    
           `</table>`; 
           this.exportXLSX(element2)
        }
      }else if(this.dashboardName =='ภาพรวมดอกรายเสาปลูกวนิลา'){
        if(type =='csv'){
          let format_list=[]
          const header = ['ฟาร์ม','แปลง','เดือน','ปี','เสาปลูก','จำนวนดอกดี','จำนวนดอกเสีย','จำนวนดอกทั้งหมด','ประเภท']
          await this.data_table.map(data=>{
            format_list.push({
              'farm_name':data.farm_name,
              'plot_name':data.plot_name,
              'month':data.month,
              'year':data.year,
              'point_name':data.point_name,
              'sum_good_data':data.sum_good_data,
              'sum_fail_data':data.sum_fail_data,
              'sum_all_data':data.sum_all_data,
              'group_type':data.group_type})
          })
          this.exportCSV(header,format_list)
        }else if (type =='xlsx'){
          var td=''
          this.data_table.map(data=>{
            td += 
            '<tr>'
            +'<td>'+data.farm_name+'</td>'
            +'<td>'+data.plot_name+'</td>'
            +'<td>'+data.month+'</td>'
            +'<td>'+data.year+'</td>'
            +'<td>'+data.point_name+'</td>'
            +'<td>'+data.sum_good_data+'</td>'
            +'<td>'+data.sum_fail_data+'</td>'
            +'<td>'+data.sum_all_data+'</td>'
            +'<td>'+data.group_type+'</td>'
            +'</tr>'
          })
      
           var element2 = `<table > 
           <tr >       
              <th >ฟาร์ม</th> 
              <th >แปลง</th> 
              <th >เดือน</th>  
              <th >ปี</th> 
              <th >เสาปลูก</th> 
              <th >จำนวนดอกดี</th> 
              <th >จำนวนดอกเสีย</th> 
              <th >จำนวนดอกทั้งหมด</th> 
              <th >ประเภท</th> 
           </tr>`+td+    
           `</table>`; 
           this.exportXLSX(element2)
        }
      }else if(this.dashboardName =='ภาพรวมดอกแต่ละแปลงการปลูกวนิลา'){
        if(type =='csv'){
          let format_list=[]
          const header = ['ฟาร์ม','เดือน','ปี','แปลง','จำนวนดอกดี','จำนวนดอกเสีย','จำนวนดอกทั้งหมด','ประเภท']
          await this.data_table.map(data=>{
            format_list.push({
              'farm_name':data.farm_name,
              'month':data.month,
              'year':data.year,
              'plot_name':data.plot_name,
              'sum_good_data':data.sum_good_data,
              'sum_fail_data':data.sum_fail_data,
              'sum_all_data':data.sum_all_data,
              'group_type':data.group_type})
          })
          this.exportCSV(header,format_list)
        }else if (type =='xlsx'){
          var td=''
          this.data_table.map(data=>{
            td += 
            '<tr>'
            +'<td>'+data.farm_name+'</td>'
            +'<td>'+data.month+'</td>'
            +'<td>'+data.year+'</td>'
            +'<td>'+data.plot_name+'</td>'
            +'<td>'+data.sum_good_data+'</td>'
            +'<td>'+data.sum_fail_data+'</td>'
            +'<td>'+data.sum_all_data+'</td>'
            +'<td>'+data.group_type+'</td>'
            +'</tr>'
          })
      
           var element2 = `<table > 
           <tr >       
              <th >ฟาร์ม</th> 
              <th >เดือน</th>  
              <th >ปี</th> 
              <th >แปลง</th> 
              <th >จำนวนดอกดี</th> 
              <th >จำนวนดอกเสีย</th> 
              <th >จำนวนดอกทั้งหมด</th> 
              <th >ประเภท</th> 
           </tr>`+td+    
           `</table>`; 
           this.exportXLSX(element2)
        }
      }else if(this.dashboardName =='ภาพรวมฝักรายปีการปลูกวนิลา'){
        if(type =='csv'){
          let format_list=[]
          const header = ['ฟาร์ม','เดือน','ปี','จำนวนฝักดี','จำนวนฝักร่วง','จำนวนฝักเน่า','จำนวนฝักที่ผสมแล้วไม่ติดฝัก','จำนวนฝักเสียไม่ทราบสาเหตุ','จำนวนฝักทั้งหมด','ประเภท']
          await this.data_table.map(data=>{
            format_list.push({'farm_name':data.farm_name,'month':data.month,'year':data.year,'sum_good_data':data.sum_good_data,
            'sum_fallen_data':data.sum_fallen_data,'sum_rotten_data':data.sum_rotten_data,'sum_breeding_issue_data':data.sum_breeding_issue_data,
            'sum_other_problem_data':data.sum_other_problem_data,'sum_all_data':data.sum_all_data,'group_type':data.group_type})
          })
          this.exportCSV(header,format_list)
        }else if (type =='xlsx'){
          var td=''
          this.data_table.map(data=>{
            td += 
            '<tr>'
            +'<td>'+data.farm_name+'</td>'
            +'<td>'+data.month+'</td>'
            +'<td>'+data.year+'</td>'
            +'<td>'+data.sum_good_data+'</td>'
            +'<td>'+data.sum_fallen_data+'</td>'
            +'<td>'+data.sum_rotten_data+'</td>'
            +'<td>'+data.sum_breeding_issue_data+'</td>'
            +'<td>'+data.sum_other_problem_data+'</td>'
            +'<td>'+data.sum_all_data+'</td>'
            +'<td>'+data.group_type+'</td>'
            +'</tr>'
          })
      
           var element2 = `<table > 
           <tr >       
              <th >ฟาร์ม</th> 
              <th >เดือน</th>  
              <th >ปี</th> 
              <th >จำนวนฝักดี</th> 
              <th >จำนวนฝักร่วง</th> 
              <th >จำนวนฝักเน่า</th> 
              <th >จำนวนฝักที่ผสมแล้วไม่ติดฝัก</th> 
              <th >จำนวนฝักเสียไม่ทราบสาเหตุ</th> 
              <th >จำนวนฝักทั้งหมด</th> 
              <th >ประเภท</th> 
           </tr>`+td+    
           `</table>`; 
           this.exportXLSX(element2)
        }
      }else if(this.dashboardName =='ภาพรวมฝักแต่ละแปลงการปลูกวนิลา'){
        if(type =='csv'){
          let format_list=[]
          const header = ['ฟาร์ม','เดือน','ปี','แปลง','จำนวนฝักดี','จำนวนฝักร่วง','จำนวนฝักเน่า','จำนวนฝักที่ผสมแล้วไม่ติดฝัก','จำนวนฝักเสียไม่ทราบสาเหตุ','จำนวนฝักทั้งหมด','ประเภท']
          await this.data_table.map(data=>{
            format_list.push({'farm_name':data.farm_name,'month':data.month,'year':data.year,'plot_name':data.plot_name,'sum_good_data':data.sum_good_data,
            'sum_fallen_data':data.sum_fallen_data,'sum_rotten_data':data.sum_rotten_data,'sum_breeding_issue_data':data.sum_breeding_issue_data,
            'sum_other_problem_data':data.sum_other_problem_data,'sum_all_data':data.sum_all_data,'group_type':data.group_type})
          })
          this.exportCSV(header,format_list)
        }else if (type =='xlsx'){
          var td=''
          this.data_table.map(data=>{
            td += 
            '<tr>'
            +'<td>'+data.farm_name+'</td>'
            +'<td>'+data.month+'</td>'
            +'<td>'+data.year+'</td>'
            +'<td>'+data.plot_name+'</td>'
            +'<td>'+data.sum_good_data+'</td>'
            +'<td>'+data.sum_fallen_data+'</td>'
            +'<td>'+data.sum_rotten_data+'</td>'
            +'<td>'+data.sum_breeding_issue_data+'</td>'
            +'<td>'+data.sum_other_problem_data+'</td>'
            +'<td>'+data.sum_all_data+'</td>'
            +'<td>'+data.group_type+'</td>'
            +'</tr>'
          })
      
           var element2 = `<table > 
           <tr >       
              <th >ฟาร์ม</th>  
              <th >เดือน</th>  
              <th >ปี</th> 
              <th >แปลง</th>  
              <th >จำนวนฝักดี</th> 
              <th >จำนวนฝักร่วง</th> 
              <th >จำนวนฝักเน่า</th> 
              <th >จำนวนฝักที่ผสมแล้วไม่ติดฝัก</th> 
              <th >จำนวนฝักเสียไม่ทราบสาเหตุ</th> 
              <th >จำนวนฝักทั้งหมด</th> 
              <th >ประเภท</th> 
           </tr>`+td+    
           `</table>`; 
           this.exportXLSX(element2)
        }
      }else if(this.dashboardName =='ภาพรวมฝักรายเสาปลูกวนิลา'){
        if(type =='csv'){
          let format_list=[]
          const header = ['ฟาร์ม','แปลง','เดือน','ปี','เสาปลูก','จำนวนฝักดี','จำนวนฝักร่วง','จำนวนฝักเน่า','จำนวนฝักที่ผสมแล้วไม่ติดฝัก','จำนวนฝักเสียไม่ทราบสาเหตุ','จำนวนฝักทั้งหมด','ประเภท']
          await this.data_table.map(data=>{
            format_list.push({
              'farm_name':data.farm_name,
              'plot_name':data.plot_name,
              'month':data.month,
              'year':data.year,
              'point_name':data.point_name,
              'sum_good_data':data.sum_good_data,
              'sum_fallen_data':data.sum_fallen_data,
              'sum_rotten_data':data.sum_rotten_data,
              'sum_breeding_issue_data':data.sum_breeding_issue_data,
              'sum_other_problem_data':data.sum_other_problem_data,
              'sum_all_data':data.sum_all_data,
              'group_type':data.group_type
            })
          })
          this.exportCSV(header,format_list)
        }else if (type =='xlsx'){
          var td=''
          this.data_table.map(data=>{
            td += 
            '<tr>'
            +'<td>'+data.farm_name+'</td>'
            +'<td>'+data.plot_name+'</td>'
            +'<td>'+data.month+'</td>'
            +'<td>'+data.year+'</td>'
            +'<td>'+data.point_name+'</td>'
            +'<td>'+data.sum_good_data+'</td>'
            +'<td>'+data.sum_fallen_data+'</td>'
            +'<td>'+data.sum_rotten_data+'</td>'
            +'<td>'+data.sum_breeding_issue_data+'</td>'
            +'<td>'+data.sum_other_problem_data+'</td>'
            +'<td>'+data.sum_all_data+'</td>'
            +'<td>'+data.group_type+'</td>'
            +'</tr>'
          })
      
           var element2 = `<table > 
           <tr >       
              <th >ฟาร์ม</th> 
              <th >แปลง</th> 
              <th >เดือน</th>  
              <th >ปี</th> 
              <th >เสาปลูก</th> 
              <th >จำนวนฝักดี</th> 
              <th >จำนวนฝักร่วง</th> 
              <th >จำนวนฝักเน่า</th> 
              <th >จำนวนฝักที่ผสมแล้วไม่ติดฝัก</th> 
              <th >จำนวนฝักเสียไม่ทราบสาเหตุ</th> 
              <th >จำนวนฝักทั้งหมด</th> 
              <th >ประเภท</th> 
           </tr>`+td+    
           `</table>`; 
           this.exportXLSX(element2)
        }
      }
    }else{
      Swal.fire({
        icon: 'warning',
        title: 'ไม่พอข้อมูลที่จะ export',
        showConfirmButton: false,
        timer: 3000
      })
    }
 

    
  }
  exportCSV(header:any,data:any) {
    let time_now =new Date()
    const replacer = (key, value) => (value === null ? '' : value);
    const datalist = Object.keys(data[0]);
    const csv = this.data_table.map((row) =>
    datalist
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');
    var link = window.document.createElement("a");
    link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvArray));
    link.setAttribute("download", this.dashboardName+'-'+(time_now.getDate() < 10 ? ('0'+time_now.getDate() ): time_now.getDate() )+'-'+((time_now.getMonth()+1) < 10 ? ('0'+(time_now.getMonth()+1) ): (time_now.getMonth()+1))+'-'+time_now.getFullYear()+'['+(time_now.getHours() < 10 ? ('0'+time_now.getHours() ): time_now.getHours() )+ '-' + (time_now.getMinutes() < 10 ? ('0'+time_now.getMinutes() ): time_now.getMinutes() )+"]"+".csv");
    link.click();
    link.remove();
    

  }
  exportXLSX(data:any){
    let time_now =new Date()
    let sheet_name = this.dashboardName+'-'+(time_now.getDate() < 10 ? ('0'+time_now.getDate() ): time_now.getDate() )+'-'+((time_now.getMonth()+1) < 10 ? ('0'+(time_now.getMonth()+1) ): (time_now.getMonth()+1))+'-'+time_now.getFullYear()+'['+(time_now.getHours() < 10 ? ('0'+time_now.getHours() ): time_now.getHours() )+ '-' + (time_now.getMinutes() < 10 ? ('0'+time_now.getMinutes() ): time_now.getMinutes() )+"]"
    let parser = new DOMParser();
    let doc = parser.parseFromString(data, 'text/html');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(doc);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    let sheet_name_split :any
    if(sheet_name.length > 31){
      sheet_name_split= sheet_name.slice(0, 31)
    }
    XLSX.utils.book_append_sheet(wb, ws, sheet_name_split);
    XLSX.writeFile(wb, sheet_name+'.xlsx');
    
  }
  format_month_eng(data){
    // data.map(obj=>{
      switch (data) {
        case 1:
          data = 'Jan.'
          break;
        case 2:
          data = 'Feb.'
          break;
        case 3:
          data = 'Mar.'
          break;
        case 4:
          data = 'Apr.'
          break;
        case 5:
          data = 'May'
          break;
        case 6:
          data = 'Jun.'
          break;
        case 7:
          data = 'Jul.'
          break;
        case 8:
          data = 'Aug.'
          break;
        case 9:
          data = 'Sep.'
          break;
        case 10:
          data = 'Oct.'
          break;
        case 11:
          data = 'Nov.'
          break;
        case 12:
          data = 'Dec.'
          break;
      }
    // })
    return data
  }

}
